import {
  Box,
  Button,
  Paper,
  Typography,
} from "@mui/material";
import { ServerDocument } from "../../../types/common";
import dayjs from "dayjs";
import { formatWithTimezone } from "../../../utils/dateHelper";
import BaseModal from "../../../components/global/BaseModal";

const PhotoModal = ({
  open,
  onClose,
  documents,
}: {
  open: boolean;
  onClose: () => void;
  documents: Array<ServerDocument>;
}) => {
  const footer = <Button onClick={onClose}>Close</Button>;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Work Completion Photos"
      footer={footer}
      maxWidth="md"
    >
      <Box
        sx={{
          p: 3,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", md: "repeat(3, minmax(0, 1fr))" },
          gap: 2,
        }}
      >
        {documents.map((it) => (
          <Paper
            key={it.id || it.original_url}
            elevation={0}
            sx={{
              overflow: "hidden",
              borderRadius: 3,
              border: (theme) =>
                `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.08)"}`,
              backdropFilter: "blur(10px)",
              p: 1.5,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box
              component="a"
              href={it.original_url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                display: "block",
                borderRadius: 2,
                overflow: "hidden",
                border: (theme) =>
                  `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)"}`,
              }}
            >
              <Box
                component="img"
                src={it.original_url}
                alt={`Work completion photo uploaded ${dayjs(it.created_at).format("MMM DD, YYYY")}`}
                sx={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              />
            </Box>
            <Box textAlign="center">
              <Typography variant="caption" color="text.secondary">
                {formatWithTimezone(it.created_at)}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>
    </BaseModal>
  );
};
export default PhotoModal;
